// Compte à rebours vers une date de fin fixe (data-fin, en ms). Un seul intervalle pour toutes les instances.
if (!customElements.get('mp-compte-a-rebours')) {
  class MpCompteARebours extends HTMLElement {
    static instances = new Set();
    static intervalle = null;

    static tic() {
      const maintenant = Date.now();
      MpCompteARebours.instances.forEach((instance) => instance.maj(maintenant));
      if (MpCompteARebours.instances.size === 0) {
        clearInterval(MpCompteARebours.intervalle);
        MpCompteARebours.intervalle = null;
      }
    }

    connectedCallback() {
      this.fin = Number(this.dataset.fin);
      // Mode boucle (data-cycle, data-ancre en secondes) : fin = prochaine limite de cycle comptée
      // depuis l'ancre, identique pour tous les visiteurs
      this.cycle = Number(this.dataset.cycle) * 1000 || 0;
      this.ancre = Number(this.dataset.ancre) * 1000 || 0;
      if (this.cycle) this.fin = this.prochaineFin(Date.now());
      this.unites = {
        j: this.querySelector('[data-unite="j"]'),
        h: this.querySelector('[data-unite="h"]'),
        m: this.querySelector('[data-unite="m"]'),
        s: this.querySelector('[data-unite="s"]'),
      };
      MpCompteARebours.instances.add(this);
      this.maj(Date.now());
      if (!MpCompteARebours.intervalle) {
        MpCompteARebours.intervalle = setInterval(MpCompteARebours.tic, 1000);
      }
    }

    disconnectedCallback() {
      MpCompteARebours.instances.delete(this);
    }

    prochaineFin(maintenant) {
      return this.ancre + Math.ceil((maintenant - this.ancre) / this.cycle) * this.cycle;
    }

    maj(maintenant) {
      if (this.cycle && this.fin - maintenant <= 0) {
        this.fin = this.prochaineFin(maintenant + 1);
      }
      const reste = Math.floor((this.fin - maintenant) / 1000);
      if (!Number.isFinite(reste) || reste <= 0) {
        this.expirer();
        return;
      }

      const deuxChiffres = (n) => String(n).padStart(2, '0');
      // Sans bloc « jours » (moins de 24 h au rendu serveur), les heures portent tout le reste.
      const heures = this.unites.j ? Math.floor((reste % 86400) / 3600) : Math.floor(reste / 3600);
      const minutes = Math.floor((reste % 3600) / 60);
      const secondes = reste % 60;

      if (this.unites.j) this.unites.j.textContent = Math.floor(reste / 86400);
      this.unites.h.textContent = deuxChiffres(heures);
      this.unites.m.textContent = deuxChiffres(minutes);
      this.unites.s.textContent = deuxChiffres(secondes);
    }

    expirer() {
      MpCompteARebours.instances.delete(this);
      const texte = this.dataset.texteExpire;
      if (texte) {
        this.textContent = texte;
        this.classList.add('mp-rebours--expire');
      } else {
        this.hidden = true;
      }
      this.dispatchEvent(new CustomEvent('mp:promo-expiree', { bubbles: true }));
    }
  }

  customElements.define('mp-compte-a-rebours', MpCompteARebours);
}
